
/**
 * Javascript file for text card.
 * @author Yannik Sprengart, Andrea Villeda
 */

export default {
    name: "TextCard",
  
    /**
     * The vue instance's data object.
     */
    data() {
      return {};
    },
  };


// WEBPACK FOOTER //
// ./src/components/company/kirc/components/textcard.js